import municipios from "./municipios";
import motivos_faltas from "./motivos_faltas";

export const $constants = {
  tiposDeMediacaoDidaticoPedagogica: ["Presencial", "Semipresencial", "Educação a distância – EAD"],
  localDeFuncionamentoDiferenciadoDaTurma: [
    "Sala anexa",
    "Unidade de atendimento socioeducativo",
    "Unidade prisional",
    "A turma não está em local de funcionamento diferenciado",
  ],
  tipoDeAtendimentoRealizado: [
    "Desenvolvimento de funções cognitivas",
    "Desenvolvimento de vida autônoma",
    "Enriquecimento curricular",
    "Ensino da informática acessível",
    "Ensino da língua brasileira de sinais",
    "Ensino da língua portuguesa como segunda língua",
    "Ensino de técnicas de orientação e mobilidade",
    "Ensino de comunicação alternativa e aumentativa",
    "Ensino do uso de recursos ópticos e não ópticos",
  ],
  aspectosObservados: [
    {
      descricao: "Habilidades trabalhadas",
      form: "horas_trabalhadas",
    },
    {
      descricao: "Descrição dos atendimentos/atividades",
      form: "descricao_atividades",
    },
    {
      descricao: "Avanços observados",
      form: "avancos_observados",
    },
    {
      descricao: "Dificuldades observadas",
      form: "dificuldades_observadas",
    },
    {
      descricao: "Frequência e participação nas atividades",
      form: "participacao_atividades",
    },
    {
      descricao: "Frequência e envolvimento da família",
      form: "envolvimento_da_familia",
    },
  ],
  diasDaSemana: [
    "Domingo",
    "Segunda-feira",
    "Terça-feira",
    "Quarta-feira",
    "Quinta-feira",
    "Sexta-feira",
    "Sábado",
  ],
  tiposDeAtendimento: [
    "Escolarização",
    "Atendimento educacional especializado (AEE)",
    "Atividade complementar",
  ],
  modalidades: [
    "Ensino regular",
    "Educação especial - modalidade substitutiva",
    "Educação de jovens e adultos",
    "Educação profissional",
  ],

  situacoesMatricula: [
    // Ativas
    // "APROVADO",
    // "REPROVADO",
    "CURSANDO",
    "RECEBIDA",

    // Inativas
    "INATIVO",
    "FALECIDO",
    "ABANDONO",
    "TRANSFERIDO",
    "CANCELADO",
    "TROCA DE TURMA",
    "TRANSFERIDO OUTROS",
  ],

  situacoesUsuarios: [
    {
      descricao: "ATIVO",
      cor: "success",
    },
    {
      descricao: "BLOQUEADO",
      cor: "error",
    },
  ],

  situacoesMatriculaCondition: {
    CURSANDO: false,
    INATIVO: true,
    FALECIDO: true,
    ABANDONO: true,
    TRANSFERIDO: true,
    CANCELADO: true,
    TROCA_DE_TURMA: true,
    TRANSFERIDO_OUTROS: true,
  },

  vinculo: [
    {
      desc: "Efetivo",
      value: 0,
    },
    {
      desc: "Celetista",
      value: 1,
    },
  ],

  bimestres: [
    {
      desc: "1° bimestre",
      value: 0,
    },
    {
      desc: "2° bimestre",
      value: 1,
    },
    {
      desc: "3° bimestre",
      value: 2,
    },
    {
      desc: "4° bimestre",
      value: 3,
    },
  ],

  planoBimestralAvalicao: [
    { label: "Seminários temáticos", value: "seminarios_tematicos" },
    { label: "Simulados", value: "simulados" },
    { label: "Produção Textual", value: "producao_textual" },
    { label: "Trabalho Individual", value: "trabalho_individual" },
    { label: "Trabalho Em Grupo", value: "trabalho_em_grupo" },
    { label: "Participação", value: "participacao" },
    { label: "Avaliação", value: "avaliacao" },
  ],

  planoBimestralDireitosAprendizagem: [
    { label: "Conviver", value: "conviver" },
    { label: "Brincar", value: "brincar" },
    { label: "Participar", value: "participar" },
    { label: "Explorar", value: "explorar" },
    { label: "Expressar", value: "expressar" },
    { label: "Conhecer-se", value: "conhecer_se" },
  ],

  planoBimestralCampoDeExperiencia: [
    { label: "O EU, O OUTRO E NÓS", value: "O EU, O OUTRO E NÓS" },
    { label: "CORPO, GESTOS E MOVIMENTOS", value: "CORPO, GESTOS E MOVIMENTOS" },
    { label: "TRAÇOS, SONS, CORES E FORMAS", value: "TRAÇOS, SONS, CORES E FORMAS" },
    {
      label: "ESCUTA, FALA, PENSAMENTO E IMAGINAÇÃO",
      value: "ESCUTA, FALA, PENSAMENTO E IMAGINAÇÃO",
    },
    {
      label: "ESPAÇOS, TEMPOS, QUANTIDADES, RELAÇÕES E TRANSFORMAÇÕES",
      value: "ESPAÇOS, TEMPOS, QUANTIDADES, RELAÇÕES E TRANSFORMAÇÕES",
    },
  ],

  planoBimestralRecursos: [
    { label: "Diferentes tipos de colas", value: "colas_diferentes" },
    { label: "Tesouras", value: "tesouras" },
    { label: "Raspas de lápis", value: "raspas_lapis" },
    { label: "Papel picado", value: "papel_picado" },
    { label: "Algodão", value: "algodao" },
    { label: "Penas", value: "penas" },
    { label: "Lápis de cor", value: "lapis_cor" },
    { label: "Canetas hidrográficas", value: "canetas_hidro" },
    { label: "EVA", value: "eva" },
    { label: "Papel color set", value: "papel_color_set" },
    { label: "Papel crepom", value: "papel_crepom" },
    { label: "Pincéis", value: "pinceis" },
    { label: "Giz de cera", value: "giz_cera" },
    { label: "Tintas guaches", value: "tintas_guache" },
    { label: "Diversos objetos, cotonetes, bexigas", value: "objetos_varios" },
    { label: "Livros de histórias infantis", value: "livros_infantis" },
    { label: "Lápis", value: "lapis" },
    { label: "Borracha", value: "borracha" },
    { label: "Bolas coloridas", value: "bolas_coloridas" },
    { label: "Bambolês", value: "bambores" },
    { label: "Tampas de garrafas pets", value: "tampas_pet" },
    { label: "Palitos de picolé", value: "palitos_picole" },
    { label: "Prendedores de roupas", value: "prendedores_roupas" },
    { label: "Material impresso", value: "material_impresso" },
    { label: "Notebook", value: "notebook" },
    { label: "Impressora", value: "impressora" },
    { label: "Folha A4", value: "folha_a4" },
    { label: "Internet", value: "internet" },
    { label: "Caixa de som", value: "caixa_som" },
    { label: "Espaço: Dentro e fora da sala de aula", value: "espaco_sala_e_fora" },
  ],

  bimestresBloqueio: [
    {
      desc: "Remover bloqueio",
      value: -1,
    },
    {
      desc: "1° bimestre",
      value: 0,
    },
    {
      desc: "2° bimestre",
      value: 1,
    },
    {
      desc: "3° bimestre",
      value: 2,
    },
    {
      desc: "4° bimestre",
      value: 3,
    },
  ],

  mesesBloqueio: [
    {
      desc: "Remover bloqueio",
      value: -1,
    },
    {
      desc: "Março",
      value: 0,
    },
    {
      desc: "Abril",
      value: 1,
    },
    {
      desc: "Maio",
      value: 2,
    },
    {
      desc: "Junho",
      value: 3,
    },
    {
      desc: "Julho",
      value: 4,
    },
    {
      desc: "Agosto",
      value: 5,
    },
    {
      desc: "Setembro",
      value: 6,
    },
    {
      desc: "Outubro",
      value: 7,
    },
    {
      desc: "Novembro",
      value: 8,
    },
  ],

  tipos_pesquisa_aluno: [
    {
      desc: "Pai",
      value: "filiacao2",
    },
    {
      desc: "Mãe",
      value: "filiacao1",
    },
    {
      desc: "Data de nasc",
      value: "data_nascimento",
    },
    {
      desc: "Gênero",
      value: "sexo_id",
    },
    {
      desc: "Cor/Raça",
      value: "cor_ou_raca",
    },
    {
      desc: "Nacionalidade",
      value: "naturalidade",
    },
    {
      desc: "País de nacionalidade",
      value: "nacionalidade",
    },
    {
      desc: "UF de nascimento",
      value: "estadualidade",
    },
  ],
  meses: [
    {
      descricao: "Janeiro",
      id: 1,
    },
    {
      descricao: "Fevereiro",
      id: 2,
    },
    {
      descricao: "Março",
      id: 3,
    },
    {
      descricao: "Abril",
      id: 4,
    },
    {
      descricao: "Maio",
      id: 5,
    },
    {
      descricao: "Junho",
      id: 6,
    },
    {
      descricao: "Julho",
      id: 7,
    },
    {
      descricao: "Agosto",
      id: 8,
    },
    {
      descricao: "Setembro",
      id: 9,
    },
    {
      descricao: "Outubro",
      id: 10,
    },
    {
      descricao: "Novembro",
      id: 11,
    },
    {
      descricao: "Dezembro",
      id: 12,
    },
  ],
  bimestresRendimentos: [
    {
      descricao: "1º BIMESTRE",
      id: 1,
    },
    {
      descricao: "2º BIMESTRE",
      id: 2,
    },
    {
      descricao: "RESULTADO DO 1º SEMESTRE",
      id: 3,
    },
    {
      descricao: "3º BIMESTRE",
      id: 4,
    },
    {
      descricao: "4º BIMESTRE",
      id: 5,
    },
    {
      descricao: "RESULTADO DO 2º SEMESTRE",
      id: 6,
    },
    {
      descricao: "RESULTADO FINAL",
      id: 7,
    },
    {
      descricao: "LISTA EM BRANCO",
      id: 8,
    },
  ],
  sistemaDeNotas: ["Numerica", "Relatório Infantil", "Relatório Individual"],
  atividadesComplementaresList: [
    {
      codigo: 11002,
      descricao: "Canto coral",
    },
    {
      codigo: 11006,
      descricao: "Banda",
    },
    {
      codigo: 11011,
      descricao: "Iniciação Musical",
    },
    {
      codigo: 12003,
      descricao: "Desenho",
    },
    {
      codigo: 12004,
      descricao: "Escultura e Cerâmica",
    },
    {
      codigo: 12005,
      descricao: "Grafite",
    },
    {
      codigo: 12007,
      descricao: "Pintura",
    },
    {
      codigo: 13001,
      descricao: "Cineclube",
    },
    {
      codigo: 14001,
      descricao: "Teatro",
    },
    {
      codigo: 14002,
      descricao: "Danças",
    },
    {
      codigo: 14004,
      descricao: "Práticas Circenses",
    },
    {
      codigo: 15001,
      descricao: "Capoeira",
    },
    {
      codigo: 15002,
      descricao: "Artesanato",
    },
    {
      codigo: 15003,
      descricao: "Brinquedos",
    },
    {
      codigo: 15004,
      descricao: "Contos",
    },
    {
      codigo: 16001,
      descricao: "Educação Patrimonial",
    },
    {
      codigo: 17004,
      descricao: "Leitura",
    },
    {
      codigo: 17002,
      descricao: "Línguas Estrangeiras",
    },
    {
      codigo: 19999,
      descricao: "Outra categoria de Cultura, Artes e Educação Patrimonial",
    },
    {
      codigo: 21001,
      descricao: "Recreação (Brinquedoteca e Jogos)",
    },
    {
      codigo: 22007,
      descricao: "Yoga",
    },
    {
      codigo: 22009,
      descricao: "Tênis de campo",
    },
    {
      codigo: 22011,
      descricao: "Atletismo",
    },
    {
      codigo: 22012,
      descricao: "Badminton",
    },
    {
      codigo: 22014,
      descricao: "Basquete",
    },
    {
      codigo: 22015,
      descricao: "Ciclismo",
    },
    {
      codigo: 22018,
      descricao: "Futebol",
    },
    {
      codigo: 22019,
      descricao: "Futsal",
    },
    {
      codigo: 22020,
      descricao: "Ginástica(rítmica, artística, acrobática)",
    },
    {
      codigo: 22021,
      descricao: "Handebol",
    },
    {
      codigo: 22022,
      descricao: "Judô",
    },
    {
      codigo: 22023,
      descricao: "Karatê",
    },
    {
      codigo: 22024,
      descricao: "Luta Olímpica",
    },
    {
      codigo: 22025,
      descricao: "Natação",
    },
    {
      codigo: 22026,
      descricao: "Taekwondo",
    },
    {
      codigo: 22027,
      descricao: "Tênis de Mesa",
    },
    {
      codigo: 22028,
      descricao: "Voleibol",
    },
    {
      codigo: 22029,
      descricao: "Vôlei de Praia",
    },
    {
      codigo: 22030,
      descricao: "Xadrez Tradicional/xadrez virtual",
    },
    {
      codigo: 29999,
      descricao: "Outra categoria de Esporte e Lazer",
    },
    {
      codigo: 22025,
      descricao: "Natação",
    },
    {
      codigo: 31002,
      descricao: "Português",
    },
    {
      codigo: 31001,
      descricao: "Matemática",
    },
    {
      codigo: 39999,
      descricao: "Outra categoria de Acompanhamento Pedagógico",
    },
    {
      codigo: 41007,
      descricao: "Educação em Direitos Humanos",
    },
    {
      codigo: 71007,
      descricao: "Promoção da Saúde",
    },
    {
      codigo: 10103,
      descricao: "Iniciação Científica",
    },
    {
      codigo: 13301,
      descricao: "Educação Ambiental e Desenvolvimento Sustentável",
    },
    {
      codigo: 13108,
      descricao: "Economia Solidária e Criativa/Educação Econômica (Educação Financeira e Fiscal)",
    },
    {
      codigo: 14101,
      descricao: "Fotografia",
    },
    {
      codigo: 14102,
      descricao: "História em Quadrinhos",
    },
    {
      codigo: 14103,
      descricao: "Jornal Escolar",
    },
    {
      codigo: 14104,
      descricao: "Rádio Escolar",
    },
    {
      codigo: 22025,
      descricao: "Vídeo",
    },
    {
      codigo: 14201,
      descricao: "Robótica Educacional",
    },
    {
      codigo: 14202,
      descricao: "Tecnologias Educacionais",
    },
    {
      codigo: 14203,
      descricao: "Ambientes de Redes Sociais",
    },
    {
      codigo: 14999,
      descricao: "Outra Categoria de Comunicação, Uso de Mídias e Cultura Digital e Tecnológica",
    },
    {
      codigo: 15101,
      descricao: "Memória e História das Comunidades Tradicionais",
    },
  ],
  sexoList: [
    {
      id: 1,
      descricao: "Masculino",
    },
    {
      id: 2,
      descricao: "Feminino",
    },
  ],
  corOuRacaList: ["Branca", "Preta", "Parda", "Amarela", "Indígena", "Não declarada", "Quilombola"],
  nacionalidadeList: [
    "Brasileira",
    "Brasileira – nascido no exterior ou naturalizado",
    "Estrangeira",
  ],
  estadosList: [
    { codigo: "AC", descricao: "Acre" },
    { codigo: "AL", descricao: "Alagoas" },
    { codigo: "AP", descricao: "Amapá" },
    { codigo: "AM", descricao: "Amazonas" },
    { codigo: "BA", descricao: "Bahia" },
    { codigo: "CE", descricao: "Ceará" },
    { codigo: "DF", descricao: "Distrito Federal" },
    { codigo: "ES", descricao: "Espírito Santo" },
    { codigo: "GO", descricao: "Goías" },
    { codigo: "MA", descricao: "Maranhão" },
    { codigo: "MT", descricao: "Mato Grosso" },
    { codigo: "MS", descricao: "Mato Grosso do Sul" },
    { codigo: "MG", descricao: "Minas Gerais" },
    { codigo: "PA", descricao: "Pará" },
    { codigo: "PB", descricao: "Paraíba" },
    { codigo: "PR", descricao: "Paraná" },
    { codigo: "PE", descricao: "Pernambuco" },
    { codigo: "PI", descricao: "Piauí" },
    { codigo: "RJ", descricao: "Rio de Janeiro" },
    { codigo: "RN", descricao: "Rio Grande do Norte" },
    { codigo: "RS", descricao: "Rio Grande do Sul" },
    { codigo: "RO", descricao: "Rondônia" },
    { codigo: "RR", descricao: "Roraíma" },
    { codigo: "SC", descricao: "Santa Catarina" },
    { codigo: "SP", descricao: "São Paulo" },
    { codigo: "SE", descricao: "Sergipe" },
    { codigo: "TO", descricao: "Tocantins" },
  ],
  municipios,
  motivos_faltas,
  tipoDeDeficienciaList: [
    "Baixa visão",
    "Cegueira",
    "Deficiência auditiva",
    "Deficiência física",
    "Deficiência intelectual",
    "Deficiência Múltipla",
    "Epilepsia",
    "Síndrome de Down",
    "Surdez",
    "Surdocegueira",
    "TDAH (Transtorno do Déficit de Atenção e Hiperatividade)",
    "Nanismo",
    "Transtornos Mentais (Esquizofrenia, Bipolar)",
    "Paralisia cerebral",
  ],
  tipoDeTranstornoDoEspectroAutistaList: ["Transtorno do espectro autista"],
  tipoDeAltasHabilidadesList: ["Altas habilidades/Superdotação"],
  recursosSaebList: [
    "Auxílio ledor",
    "Tradutor-intérprete de Libras",
    "Prova superampliada (Fonte 24)",
    "Auxílio transcrição",
    "Leitura labial",
    "CD com áudio para deficiente visual",
    "Guia-intérprete",
    "Prova ampliada (Fonte 18)",
    "Prova de Língua Portuguesa como Segunda Língua para surdos e deficientes auditivos",
    "Prova em Video Libras",
    "Material didático e prova em Braille",
    "Nenhum",
  ],
  zonaResidenciaList: ["Urbana", "Rural"],
  localizacaoDiferenciadaDeResidenciaList: [
    "Não está em área de localização diferenciada",
    "Área onde se localiza comunidade remanescente de quilombos",
    "Terra indígena",
    "Área de assentamento",
  ],
  rolesParaProfessores: [
    {
      id: "2",
      name: "professor",
    },
    {
      id: "11",
      name: "prof-auxiliar",
    },
    // {
    //   id: "5",
    //   name: "coordenador",
    // },
    // {
    //   id: "10",
    //   name: "coordenador semed",
    // },
    // {
    //   id: "7",
    //   name: "direção",
    // },
    // {
    //   id: "8",
    //   name: "supervisor",
    // },
    // {
    //   id: "1",
    //   name: "secretario",
    // },
    // {
    //   id: "3",
    //   name: "admin",
    // },
  ],
  rolesParaGestores: [
    {
      id: "1",
      name: "admin",
    },
    {
      id: "4",
      name: "secretario",
    },
    {
      id: "6",
      name: "super-admin",
    },
    {
      id: "9",
      name: "tec-admin",
    },
    {
      id: "7",
      name: "direção",
    },
    {
      id: "5",
      name: "coordenador",
    },
    {
      id: "10",
      name: "coordenador semed",
    },
    {
      id: "15",
      name: "TI",
    },
  ],
  tiposDeAulas: [
    "Aula Remota",
    "Aula Normal",
    "Reposição",
    "Aula Extra",
    "Substituição",
    "Aula Antecipada",
    "Atividade Extra-classe",
    "Recuperação",
  ],
  situacoesPlanos: [
    {
      id: 1,
      descricao: "Plano Confirmado",
      cor: "green",
    },
    {
      id: 2,
      descricao: "Aguardando confirmação",
      cor: "orange",
    },
    {
      id: 3,
      descricao: "Plano Inválido",
      cor: "red",
    },
  ],
  // situacoesAulas: [
  //   {
  //     descricao: "Aula confirmada",
  //     cor: "success",
  //   },
  //   {
  //     descricao: "Aguardando confirmação",
  //     cor: "blue-grey lighten-4",
  //   },
  //   {
  //     descricao: "Aula rejeitada por falta",
  //     cor: "error",
  //   },
  //   {
  //     descricao: "Aula inválida",
  //     cor: "brown lighten-3",
  //   },
  //   {
  //     descricao: "Aula em conflito",
  //     cor: "warning",
  //   },
  // ],

  listCamposAulasLancadas: {
    conteudo: "Conteúdo",
    objetivos_ou_habilidades: "Objetivos ou Habilidades",
    metodologia: "Metodologia",
    // campos para a criação de aulas infantis
    campos_de_experiencias: "Campos de experiências",
    conteudo_polivalencia: "Conteúdo polivalência",
    // eixos: "Eixos",
    estrategias: "Estrategias",
    recursos: "Recursos",
    // atividade_classe: "Atividade de classe",
    atividade_casa: "Atividade de casa",
    observacoes: "Observações",
  },

  situacoesAulas: [
    {
      descricao: "Aula confirmada",
      cor: "green",
    },
    {
      descricao: "Aguardando confirmação",
      cor: "blue-grey lighten-4",
    },
    {
      descricao: "Aula rejeitada por falta",
      cor: "error",
    },
    {
      descricao: "Aula inválida",
      cor: "error",
    },
    {
      descricao: "Aula em conflito",
      cor: "warning",
    },
  ],
  situacoesAulasTabs: [
    {
      descricao: "Confirmadas",
      cor: "green lighten-4",
      tipo: "Aula confirmada",
    },
    {
      descricao: "Aguardando",
      cor: "blue-grey lighten-4",
      tipo: "Aguardando confirmação",
    },
    {
      descricao: "Rejeitadas",
      cor: "red lighten-4",
      tipo: "Aula rejeitada por falta",
    },
    {
      descricao: "Inválidas",
      cor: "brown lighten-5",
      tipo: "Aula inválida",
    },
    {
      descricao: "Conflitadas",
      cor: "amber lighten-4",
      tipo: "Aula em conflito",
    },
  ],
  situacoesAulasCor: {
    "Aula confirmada": "green lighten-2",
    "Aguardando confirmação": "blue-grey lighten-2",
    "Aula rejeitada por falta": "red lighten-2",
    "Aula inválida": "brown lighten-3",
    "Aula em conflito": "amber lighten-2",
  },
  situacoesAulasCorLight: {
    "Aula confirmada": "green lighten-4",
    "Aguardando confirmação": "blue-grey lighten-4",
    "Aula rejeitada por falta": "red lighten-4",
    "Aula inválida": "brown lighten-5",
    "Aula em conflito": "amber lighten-4",
  },
  subEtapaTipoCampos: [
    {
      descricao: "Valor (Inserir) - Número",
      slug: "valor",
    },
    {
      descricao: "Valor (Inserir) - Texto",
      slug: "valor_texto",
    },
    {
      descricao: "Resultado em número",
      slug: "resultado_em_lote",
    },
    {
      descricao: "Resultado em Texto",
      slug: "resultado_em_texto",
    },
  ],
  situacaoAutorizacao: ["PENDENTE", "RECUSADO", "APROVADO"],
  coresPrimarias: [
    {
      descricao: "Verde",
      codigo: "#00FF00",
    },
    {
      descricao: "Vermelho",
      codigo: "#FF0000",
    },
    {
      descricao: "Azul",
      codigo: "#0000FF",
    },
    {
      descricao: "Preto",
      codigo: "black",
    },
    {
      descricao: "Rosa",
      codigo: "pink",
    },
  ],
  optionsInformativo: [
    { title: "Restringir a um grupo" },
    { title: "Definir data para mostrar" },
    { title: "Definir data para encerrar" },
  ],

  mesesPlanoMensal: [
    {
      descricao: "Março",
      id: 0,
    },
    {
      descricao: "Abril",
      id: 1,
    },
    {
      descricao: "Maio",
      id: 2,
    },
    {
      descricao: "Junho",
      id: 3,
    },
    {
      descricao: "Julho",
      id: 4,
    },
    {
      descricao: "Agosto",
      id: 5,
    },
    {
      descricao: "Setembro",
      id: 6,
    },
    {
      descricao: "Outubro",
      id: 7,
    },
    {
      descricao: "Novembro",
      id: 8,
    },
  ],
  situacaoHistorico: ["APROVADO", "REPROVADO"],

  situacoesAdversas: [
    "INATIVO",
    "FALECIDO",
    "ABANDONO",
    "TRANSFERIDO",
    "CANCELADO",
    "TROCA DE TURMA",
    "TRANSFERIDO OUTROS",
  ],

  tooltips: {
    avisos: {
      criarAviso:
        "Permite criar avisos para determinados grupos de usuários. Podendo serem mensagens diretas para turmas, escolas inteiras ou alunos específicos. Você poderá anexar imagens, a mensagem propriamente dita e um título para ela.",
    },
    matriculas: {
      criarMatricula:
        "Permite matricular um aluno em uma unidade escolar, especificando sua turma e etapa. Além disso, é possível pesquisar por alunos e obter declarações sobre sua matrícula através do botão “Ações”. Também é possível verificar a situação do aluno e excluir sua matrícula.",
      criarAluno:
        "Permite cadastrar alunos, inserindo dados pessoais, residenciais e laudos médicos. Também possibilita a pesquisa por alunos específicos, a visualização de seus históricos escolares, a edição de suas fichas cadastrais e a exclusão de seus perfis.",
      pesquisaAvancadaDeAlunos:
        "Neste módulo, é possível pesquisar com maior abrangência por alunos de todas as escolas do município. A funcionalidade mais relevante está na opção 'Migrar', que altera a situação dos alunos para diferentes status, além de efetivamente transferi-los entre unidades escolares do município ou para outra unidade de ensino.",
    },
    turmas: {
      criarTurma:
        "Este módulo lista e cria turmas na unidade escolar atual. Ao criar turmas, informações importantes como turno, etapa, circuito de notas e tipo de ensino devem ser inseridas. Além de permitir editar e excluir turmas, é possível verificar a situação de presenças para fins do Bolsa Família e acompanhar as métricas da turma.",
      criarAno:
        "Neste modulo possui as etapas ministradas na unidade escolar. Elas são definidas conforme o Censo Escolar, podendo o usuário selecionar os componentes curriculares que serão lecionadas em cada uma delas.",
      criarDisciplina:
        "Neste módulo, são criadas os componentes curriculares que compõem o conjunto de matérias de cada etapa. Aqui serão atribuídos o nome e o código identificador de cada componente curricular.",
    },
    planos: {
      listarPlanos:
        "Neste módulo, é possível visualizar os diversos planos de aulas lançados pelos professores da unidade escolar atual, podendo pesquisá-los por componente curricular, turma, bimestre ou nome de um professor específico.",
      listarPlanosInfantil:
        "Neste módulo, é possível visualizar os diversos planos de aulas infantis lançados pelos professores da unidade escolar atual, podendo pesquisá-los por componente curricular, turma, bimestre ou nome de um professor específico.",
      DocumentosPlanos:
        "Este módulo é destinado para o cadastro do documento de plano bimestral, onde é determinado a etapa correspondente àquele plano, o bimestre do plano e o componente curricular. Com todo o cadastro feito, esse documento será exibido na criação do plano bimestral, tanto do fundamental, quanto do infantil.",
    },
    diarioOnline: {
      criarVinculo:
        "Neste módulo estão disponíveis as ferramentas fundamentais para o trabalho do professor. Aulas, notas, planos de aula e frequência serão registradas aqui. Através do botão “Ações” na gestão desejada, é possível acessar diferentes funções de apoio ao trabalho pedagógico.",
      diarioGeral:
        "Neste módulo, através de um perfil habilitado, é possível acessar notas e aulas de todas as gestões do município.",
      agendas:
        "Neste módulo, é possível enviar atividades escolares para turmas determinadas. Ao criar uma agenda, uma notificação aparecerá na página inicial dos alunos da turma selecionada.",
      pendenciasDeProfessores:
        "Este módulo evidencia as pendências dos professores quanto a aulas, notas, planos e frequência, mostrando a expectativa de lançamentos, a quantidade de dados efetivamente inseridos e os dados que ainda faltam ser registrados.",
    },
    relatorios: {
      verTodos:
        "Neste módulo, encontram-se diversos relatórios que auxiliam tanto professores quanto gestores municipais. É possível identificar dados sensíveis e importantes, que variam conforme o tipo de usuário que os acessa. Entre eles estão relatórios de quantidade de alunos, movimentação escolar, boletins, entre outros.",
    },
    usuarios: {
      criarProfessor:
        "Neste módulo, é possível cadastrar professores na unidade escolar, inserindo informações como nome, carga horária, unidade escolar a ser vinculada, entre outros dados.",
      bloqueioELiberacao:
        "Neste módulo, há o controle de bloqueios e liberações para perfis determinados. É possível bloquear perfis ou grupos de perfis, total ou parcialmente, restringindo atividades ou apenas o acesso a aulas e planos. A lista de perfis permite visualizar o tipo de perfil, situação atual, data de bloqueio (se houver), bem como sua edição ou exclusão.",
      criarUsuario:
        "Neste módulo, é possível verificar os dados e pesquisar por todos os usuários cadastrados no sistema, como professores e gestores, exceto alunos.",
    },
    administracao: {
      criarFranquia:
        "Neste módulo, ocorre a criação e inclusão de unidades escolares no sistema do município. É possível preencher nome, código, endereço e telefone de contato dos responsáveis pelas unidades escolares, podendo cada uma dessas informações ser editada ou excluída.",
      criarCircuito:
        "Aqui é configurado o sistema de notas do município, estabelecendo as datas de início e encerramento de cada etapa do ano letivo. É possível editar essas informações e estender prazos para registro de aulas e notas pelos professores em cada etapa. Além disso, o sistema disponibiliza registro de regras e layout dos boletins.",
      bolsaFamilia:
        "Este módulo configura a frequência mínima de presença de alunos para cada tipo de ensino no município, visando garantir a elegibilidade para o recebimento do auxílio do Bolsa Família.",
    },
    desempenhoPedagogico: {
      desempenhoProfessor:
        "Esta aba evidencia os dados de cada gestao do professor, com o intuito de verificar seu desempenho referente ao lançamento esperado de aulas, frequencias, notas e planos. Em cada professor possui em porcentagem seu desempenho referente as suas gestoes.",
      desempenhoCoordenador:
        "Esta aba evidencia os dados de cada turma na unidade escolar do coordenador responsável, com o intuito de verificar seu desempenho referente a confirmação de aulas e planos. Em cada turma possui seu desempenho referente a confirmação de dados em porcentagem.",
    },
    calendarioLetivo: {
      painelAdministrativo:
        "O calendário letivo permite inserir eventos em dias determinados do mês. Esses eventos podem incluir feriados, sábados letivos ou outros acontecimentos, categorizados conforme decisão de usuários com permissão.",
      categoria:
        "Esta aba tem como intuito de cadastrar a categoria do evento, onde será determinado o nome da categoria, a cor desejada e se será permitido o lançamento de aulas ou não para aquela categoria. Dessa forma, cada evento adicionado no Calendário letivo deve ter sua categoria correspondente.",
    },
    aulas: {
      horarios:
        "Somente serão apresentados os horários das disciplinas que possuem Dia, Horário e Disciplina cadastradas, conforme configuração realizada na criação ou edição do vínculo da gestão.",
      duplicarAulaPolivalente:
        "Todas as disciplinas deverão possuir horários cadastrados para a data selecionada para a duplicação de aulas polivalentes. Caso contrário, os horários não serão apresentados.",
      exportarAulaPolivalente:
        "Todas as disciplinas deverão possuir horários cadastrados para a data e turma de origem selecionada para a exportação de aulas polivalentes. Caso contrário, os horários não serão apresentados.",
      replicarAula: "Cria novas aulas com as mesmas informações em todos os horários selecionados.",
    },
  },
};

export default (vue) => {
  vue.prototype.$constants = $constants;
};
